import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend'; // primary use cache
import XHR from 'i18next-xhr-backend'; // fallback xhr load
import LanguageDetector from 'i18next-browser-languagedetector';


i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',

    // have a common namespace used around the full app
    ns: ['translations', 'flo-components'],
    defaultNS: 'translations',

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    },

    load: 'languageOnly',

    react: {
      useSuspense: false,
      wait: true,
    },

    backend: {
      backends: [
        LocalStorageBackend,  // primary
        XHR                   // fallback
      ],
      backendOptions: [{
        // prefix for stored languages
        prefix: 'i18next_res_v1_',

        // expiration
        expirationTime: 7*24*60*60*1000,

        // language versions
        versions: { en: 'v1.40', es: 'v1.40', fr: 'v1.40' },

        // can be either window.localStorage or window.sessionStorage. Default: window.localStorage
        store: window.localStorage
      }, {
        loadPath: '/static/locales/{{lng}}/{{ns}}.json' // xhr load path for my own fallback
      }]
    }
  });
